"use strict";

var seed = 0;
module.exports = function guid() {
  return Date.now() + "_" + seed++;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-util/lib/guid.js
// module id = 461
// module chunks = 9